var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4367_1077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0212 18.3408C14.2258 17.993 14.3438 17.5882 14.3438 17.1562C14.3438 15.8639 13.2923 14.8125 12 14.8125C10.7077 14.8125 9.65625 15.8639 9.65625 17.1562C9.65625 17.5882 9.77419 17.993 9.97884 18.3408C8.89425 18.8078 8.13281 19.8868 8.13281 21.1406V23.25C8.13281 23.6383 8.44762 23.9531 8.83594 23.9531H15.1641C15.5524 23.9531 15.8672 23.6383 15.8672 23.25V21.1406C15.8672 19.8868 15.1058 18.8078 14.0212 18.3408Z",
    fill: "#C42B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93522 10.6065C6.13987 10.2586 6.25781 9.85387 6.25781 9.42188C6.25781 8.12953 5.20641 7.07812 3.91406 7.07812C2.62172 7.07812 1.57031 8.12953 1.57031 9.42188C1.57031 9.84731 1.68483 10.2463 1.88381 10.5906C0.779156 11.0486 0 12.138 0 13.4062V15.5156C0 15.9039 0.314812 16.2188 0.703125 16.2188H7.07812C7.46644 16.2188 7.78125 15.9039 7.78125 15.5156V13.4062C7.78125 12.1524 7.01981 11.0734 5.93522 10.6065Z",
    fill: "#C42B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.154 10.6065C22.3586 10.2586 22.4766 9.85387 22.4766 9.42188C22.4766 8.12953 21.4252 7.07812 20.1328 7.07812C18.8405 7.07812 17.7891 8.12953 17.7891 9.42188C17.7891 9.84731 17.9036 10.2463 18.1026 10.5906C16.9979 11.0486 16.2188 12.138 16.2188 13.4062V15.5156C16.2188 15.9039 16.5336 16.2188 16.9219 16.2188H23.2969C23.6852 16.2188 24 15.9039 24 15.5156V13.4062C24 12.1524 23.2386 11.0734 22.154 10.6065Z",
    fill: "#C42B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0212 3.5752C14.2258 3.22734 14.3438 2.82258 14.3438 2.39062C14.3438 1.09828 13.2923 0.046875 12 0.046875C10.7077 0.046875 9.65625 1.09828 9.65625 2.39062C9.65625 2.82258 9.77419 3.22734 9.97884 3.5752C8.89425 4.04217 8.13281 5.12119 8.13281 6.375V8.48438C8.13281 8.87269 8.44762 9.1875 8.83594 9.1875H15.1641C15.5524 9.1875 15.8672 8.87269 15.8672 8.48438V6.375C15.8672 5.12119 15.1058 4.04217 14.0212 3.5752Z",
    fill: "#C42B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4062 18.3281C19.4062 19.4912 18.46 20.4375 17.2969 20.4375H17.2175C17.2862 20.8686 17.2734 21.1048 17.2734 21.8438C19.291 21.8438 20.8125 20.2204 20.8125 18.3281V17.625H19.4062V18.3281Z",
    fill: "#C42B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7201 2.85938H17.2969C18.46 2.85938 19.4063 3.80564 19.4063 4.96875V5.74312C19.8666 5.65237 20.3353 5.64694 20.8125 5.73473V4.96875C20.8125 3.03023 19.2354 1.45312 17.2969 1.45312H15.6313C15.7456 1.89567 15.7817 2.37183 15.7201 2.85938Z",
    fill: "#C42B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61719 5.73895V4.96875C4.61719 3.80564 5.56345 2.85938 6.72656 2.85938H8.27995C8.22197 2.40061 8.24709 1.92389 8.36869 1.45312H6.72656C4.78805 1.45312 3.21094 3.03023 3.21094 4.96875V5.73895C3.68002 5.64956 4.14769 5.64952 4.61719 5.73895Z",
    fill: "#C42B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61719 18.3281V17.625H3.21094V18.3281C3.21094 20.2666 4.78805 21.8438 6.72656 21.8438C6.72656 21.1042 6.71381 20.8683 6.78253 20.4375H6.72656C5.56345 20.4375 4.61719 19.4912 4.61719 18.3281Z",
    fill: "#C42B7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4367_1077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon13.488e53b77706fa35f4ef79c14fb58912.svg";
export { ForwardRef as ReactComponent };